import {useEffect, useState} from "react";
import {findCouponsWithPagination} from "../api/eventGroupApiClient";

export const useCoupons = (page, pageSize, reloadTrigger = 0) => {
    const [coupons, setCoupons] = useState([]);
    const [pagination, setPagination] = useState(null);

    useEffect(() => {
        const abortController = new AbortController();
        const couponsWithPagination = findCouponsWithPagination(page, pageSize, abortController.signal);

        couponsWithPagination
            .then(
                (data) => {
                    const coupons = data.coupons;
                    const pagination = data.pagination;

                    setCoupons(coupons);
                    setPagination(pagination);
                }
            )
            .catch(
                (error) => console.log(error)
            );

        return () => {
            abortController.abort();
        };
    }, [page, pageSize, reloadTrigger]);

    return {coupons : coupons, pagination};
};
